// modules are defined as an array
// [ module function, map of requires ]
//
// map of requires is short require name -> numeric require
//
// anything defined in a previous bundle is accessed via the
// orig method which is the require for previous bundles

(function (
  modules,
  entry,
  mainEntry,
  parcelRequireName,
  externals,
  distDir,
  publicUrl,
  devServer
) {
  /* eslint-disable no-undef */
  var globalObject =
    typeof globalThis !== 'undefined'
      ? globalThis
      : typeof self !== 'undefined'
      ? self
      : typeof window !== 'undefined'
      ? window
      : typeof global !== 'undefined'
      ? global
      : {};
  /* eslint-enable no-undef */

  // Save the require from previous bundle to this closure if any
  var previousRequire =
    typeof globalObject[parcelRequireName] === 'function' &&
    globalObject[parcelRequireName];

  var importMap = previousRequire.i || {};
  var cache = previousRequire.cache || {};
  // Do not use `require` to prevent Webpack from trying to bundle this call
  var nodeRequire =
    typeof module !== 'undefined' &&
    typeof module.require === 'function' &&
    module.require.bind(module);

  function newRequire(name, jumped) {
    if (!cache[name]) {
      if (!modules[name]) {
        if (externals[name]) {
          return externals[name];
        }
        // if we cannot find the module within our internal map or
        // cache jump to the current global require ie. the last bundle
        // that was added to the page.
        var currentRequire =
          typeof globalObject[parcelRequireName] === 'function' &&
          globalObject[parcelRequireName];
        if (!jumped && currentRequire) {
          return currentRequire(name, true);
        }

        // If there are other bundles on this page the require from the
        // previous one is saved to 'previousRequire'. Repeat this as
        // many times as there are bundles until the module is found or
        // we exhaust the require chain.
        if (previousRequire) {
          return previousRequire(name, true);
        }

        // Try the node require function if it exists.
        if (nodeRequire && typeof name === 'string') {
          return nodeRequire(name);
        }

        var err = new Error("Cannot find module '" + name + "'");
        err.code = 'MODULE_NOT_FOUND';
        throw err;
      }

      localRequire.resolve = resolve;
      localRequire.cache = {};

      var module = (cache[name] = new newRequire.Module(name));

      modules[name][0].call(
        module.exports,
        localRequire,
        module,
        module.exports,
        globalObject
      );
    }

    return cache[name].exports;

    function localRequire(x) {
      var res = localRequire.resolve(x);
      if (res === false) {
        return {};
      }
      // Synthesize a module to follow re-exports.
      if (Array.isArray(res)) {
        var m = {__esModule: true};
        res.forEach(function (v) {
          var key = v[0];
          var id = v[1];
          var exp = v[2] || v[0];
          var x = newRequire(id);
          if (key === '*') {
            Object.keys(x).forEach(function (key) {
              if (
                key === 'default' ||
                key === '__esModule' ||
                Object.prototype.hasOwnProperty.call(m, key)
              ) {
                return;
              }

              Object.defineProperty(m, key, {
                enumerable: true,
                get: function () {
                  return x[key];
                },
              });
            });
          } else if (exp === '*') {
            Object.defineProperty(m, key, {
              enumerable: true,
              value: x,
            });
          } else {
            Object.defineProperty(m, key, {
              enumerable: true,
              get: function () {
                if (exp === 'default') {
                  return x.__esModule ? x.default : x;
                }
                return x[exp];
              },
            });
          }
        });
        return m;
      }
      return newRequire(res);
    }

    function resolve(x) {
      var id = modules[name][1][x];
      return id != null ? id : x;
    }
  }

  function Module(moduleName) {
    this.id = moduleName;
    this.bundle = newRequire;
    this.require = nodeRequire;
    this.exports = {};
  }

  newRequire.isParcelRequire = true;
  newRequire.Module = Module;
  newRequire.modules = modules;
  newRequire.cache = cache;
  newRequire.parent = previousRequire;
  newRequire.distDir = distDir;
  newRequire.publicUrl = publicUrl;
  newRequire.devServer = devServer;
  newRequire.i = importMap;
  newRequire.register = function (id, exports) {
    modules[id] = [
      function (require, module) {
        module.exports = exports;
      },
      {},
    ];
  };

  // Only insert newRequire.load when it is actually used.
  // The code in this file is linted against ES5, so dynamic import is not allowed.
  // INSERT_LOAD_HERE

  Object.defineProperty(newRequire, 'root', {
    get: function () {
      return globalObject[parcelRequireName];
    },
  });

  globalObject[parcelRequireName] = newRequire;

  for (var i = 0; i < entry.length; i++) {
    newRequire(entry[i]);
  }

  if (mainEntry) {
    // Expose entry point to Node, AMD or browser globals
    // Based on https://github.com/ForbesLindesay/umd/blob/master/template.js
    var mainExports = newRequire(mainEntry);

    // CommonJS
    if (typeof exports === 'object' && typeof module !== 'undefined') {
      module.exports = mainExports;

      // RequireJS
    } else if (typeof define === 'function' && define.amd) {
      define(function () {
        return mainExports;
      });
    }
  }
})({"kJVwu":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
var _isPast = require("date-fns/isPast");
var _isFuture = require("date-fns/isFuture");
var _isToday = require("date-fns/isToday");
var _addMinutes = require("date-fns/addMinutes");
var _subMinutes = require("date-fns/subMinutes");
var _parseISO = require("date-fns/parseISO");
var _differenceInMinutes = require("date-fns/differenceInMinutes");
var _isNumber = require("lodash/isNumber");
var _isNumberDefault = parcelHelpers.interopDefault(_isNumber);
var _odds = require("./odds");
var _sportnyhetDataScss = require("./sportnyhet-data.scss");
var query = function() {
    var selector = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "", parent = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : document;
    return parent.querySelector(selector);
};
var queryAll = function() {
    var selector = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "", parent = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : document;
    return Array.from(parent.querySelectorAll(selector));
};
var getCurrentTime = function() {
    var instance = new Date();
    return instance.getTime();
};
var getMatches = function() {
    return queryAll(".sn-scores").map(function(el) {
        var _el_dataset = el.dataset, id = _el_dataset.id, startTime = _el_dataset.startTime;
        return {
            id: id,
            startTime: startTime,
            startsAt: (0, _parseISO.parseISO)(startTime),
            hasLiveOdds: !!query(".sn-live-odds", el.parentNode.parentNode)
        };
    });
};
var isMatchPlaying = function(param) {
    var startsAt = param.startsAt, hasLiveOdds = param.hasLiveOdds;
    return (0, _isToday.isToday)(startsAt) && (0, _isPast.isPast)(startsAt) || hasLiveOdds;
};
var getPlayingMatches = function() {
    return getMatches().filter(isMatchPlaying);
};
var shouldUpdateMatches = function() {
    return getPlayingMatches().length;
};
var updateMatches = function(data) {
    var matches = data.flat();
    if (!matches.length) return;
    queryAll(".sn-scores").forEach(function(el) {
        var sport = el.dataset.sport;
        var match = matches.find(function(param) {
            var unique = param.unique;
            return unique === el.dataset.matchId;
        });
        var parentElement = el.parentNode.parentNode;
        var oddsElement = query(".sn-live-odds", parentElement);
        if (oddsElement && !match) hideMatch(parentElement);
        if (!match) return;
        var status = match.status, timer = match.timer, period = match.period, datetime = match.datetime, _match_home = match.home, homeScore = _match_home.totalscore, _match_away = match.away, awayScore = _match_away.totalscore, odds = match.live.odds;
        var startsAt = null;
        if (datetime) startsAt = (0, _parseISO.parseISO)(datetime);
        if ((!status || status === "not-started") && !oddsElement) return;
        var timerElement = query(".sn-timer", el.parentNode);
        var periodElement = query(".sn-period", el.parentNode);
        var _periodElement_dataset = periodElement.dataset, periodLabel = _periodElement_dataset.label, breakLabel = _periodElement_dataset.break;
        var overTimeLabel = periodElement.dataset.overTime;
        var isPlaying = false;
        if (timerElement) {
            if ([
                "break-time",
                "et",
                "wo",
                "int",
                "half-time",
                "ht"
            ].includes(status)) {
                timerElement.innerText = "";
                timerElement.classList.add("sn-timer-active");
                if (periodElement) periodElement.innerText = breakLabel || "";
                isPlaying = true;
            } else if (status === "over-time") {
                timerElement.innerText = "";
                timerElement.classList.add("sn-timer-active");
                if (periodElement) periodElement.innerText = overTimeLabel || "";
                isPlaying = true;
            } else if (status !== "not-started" && ((0, _isNumberDefault.default)(status) || timer > 0 || /^\d+$/.test(status) || [
                "1st-half",
                "2nd-half"
            ].includes(status))) {
                timerElement.innerText = timer;
                timerElement.classList.add("sn-timer-active");
                if (periodElement) {
                    var str = period && (0, _isNumberDefault.default)(period) ? "".concat(periodLabel, " ").concat(period) : period;
                    periodElement.innerText = period ? str : "";
                }
                el.classList.add("sn-scores-active");
                isPlaying = true;
            } else {
                timerElement.innerText = "";
                timerElement.classList.remove("sn-timer-active");
                if (periodElement) periodElement.innerText = "";
            }
            if (period !== undefined) {
                timerElement.classList[period ? "add" : "remove"]("sn-timer-active");
                if (period) isPlaying = true;
            }
        }
        if (isPlaying && oddsElement || !oddsElement) showMatch(parentElement);
        query(".sn-score--home", el).innerText = homeScore;
        query(".sn-score--away", el).innerText = awayScore;
        if (oddsElement) {
            var _oddsElement_dataset = oddsElement.dataset, url = _oddsElement_dataset.url, label = _oddsElement_dataset.label, types = _oddsElement_dataset.types;
            oddsElement.innerHTML = "";
            if (isPlaying && Array.isArray(odds)) {
                var oddsHTML = (0, _odds.createOddsElement)({
                    sport: sport,
                    odds: odds,
                    url: url,
                    label: label,
                    types: JSON.parse(types)
                });
                if (oddsHTML) oddsElement.innerHTML = oddsHTML;
            }
            if (!isPlaying) {
                var hide = true;
                if (startsAt !== null) {
                    var diff = (0, _differenceInMinutes.differenceInMinutes)(startsAt, new Date());
                    if (diff < 60) hide = false;
                    if (diff < -170) hide = true;
                }
                if (hide) hideMatch(parentElement);
            }
        }
    });
    setTimeout(function() {
        fetchData().then(updateMatches).catch(console.error);
    }, 30000);
};
var hideMatch = function(parentElement) {
    parentElement.style.display = "none";
    if (parentElement.parentNode) {
        var foundVisible = false;
        queryAll(".sn-row", parentElement.parentNode).filter(function(el) {
            return !el.classList.contains("sn-row--head");
        }).forEach(function(el) {
            if (el.style.display !== "none") foundVisible = true;
        });
        if (!foundVisible) parentElement.parentNode.style.display = "none";
    }
};
var showMatch = function(parentElement) {
    parentElement.removeAttribute("style");
    if (parentElement.parentNode) parentElement.parentNode.removeAttribute("style");
};
var fetchData = function() {
    var ts = getCurrentTime();
    return Promise.all(Array.from(new Set(queryAll(".sn-scores").map(function(param) {
        var _param_dataset = param.dataset, sport = _param_dataset.sport, leagueId = _param_dataset.leagueId, country = _param_dataset.country;
        return {
            sport: sport,
            leagueId: leagueId,
            country: country
        };
    }).map(function(param) {
        var sport = param.sport, leagueId = param.leagueId, country = param.country;
        return "/wp-json/sportnyhet/v3/sports/".concat(sport || "hockey", "/sources/livescores/countries/").concat(country, "/leagues/").concat(leagueId, "/items?ts=").concat(ts);
    }))).map(function(url) {
        return fetch(url, {
            method: "POST"
        }).then(function(response) {
            if (!response.ok) throw new Error("Endpoint error");
            return response.json();
        });
    }));
};
var init = function() {
    return new Promise(function(resolve, reject) {
        if (shouldUpdateMatches()) return resolve();
        var i = setInterval(function() {
            if (shouldUpdateMatches()) {
                clearInterval(i);
                resolve();
            }
        }, 10000);
    });
};
init().then(fetchData).then(updateMatches).catch(console.error);
var switcher = query(".sn-switcher");
if (switcher) window.addEventListener("click", function(param) {
    var target = param.target;
    if (!switcher.contains(target)) switcher.classList.remove("sn-switcher--active");
});
queryAll(".sn-switch").forEach(function(el) {
    el.addEventListener("click", function() {
        var parent = el.parentNode.parentNode;
        parent.classList.toggle("sn-switcher--active", el.getAttribute("aria-selected") === "true");
        queryAll(".sn-switch", parent).forEach(function(item) {
            item.setAttribute("aria-selected", item === el ? "true" : "false");
            var panelId = item.getAttribute("aria-controls");
            var panel = query("#".concat(panelId));
            if (panel) panel.style.display = item === el ? "block" : "none";
        });
    });
});
(function() {
    var showOddsLiveBtnTables = queryAll(".sn-table--show-live-odds-btn");
    var updateOddsLiveBtn = function() {
        return showOddsLiveBtnTables.forEach(function(tbl) {
            var _tbl_dataset, _tbl_dataset1, _tbl_dataset2;
            var sport = ((_tbl_dataset = tbl.dataset) === null || _tbl_dataset === void 0 ? void 0 : _tbl_dataset.sport) || null;
            var approxEnd = 150; // Hockey
            switch(sport){
                case "handball":
                    approxEnd = 60;
                    break;
                case "soccer":
                    approxEnd = 90;
                    break;
            }
            var isLivescores = !!tbl.className.match(/sn-table--livescores/);
            var label = (_tbl_dataset1 = tbl.dataset) === null || _tbl_dataset1 === void 0 ? void 0 : _tbl_dataset1.oddslivebtnLabel;
            var link = (_tbl_dataset2 = tbl.dataset) === null || _tbl_dataset2 === void 0 ? void 0 : _tbl_dataset2.oddslivebtnLink;
            if (!label || !link) // No label or link. Skip.
            return;
            queryAll(".sn-row", tbl).forEach(function(row) {
                var _row_dataset;
                var time = query(".sn-cell--time time", row);
                var status = ((_row_dataset = row.dataset) === null || _row_dataset === void 0 ? void 0 : _row_dataset.status) || null;
                if (!time) // No time element. Skip.
                return;
                var dateTime = time.getAttribute("datetime");
                if (!dateTime) // No datetime. Skip.
                return;
                var dt = (0, _parseISO.parseISO)(dateTime);
                var isPlaying = false;
                if (!status || ![
                    "ft",
                    "finished",
                    "after-penalties",
                    "pen",
                    "after-over-time",
                    "aet"
                ].includes(status)) isPlaying = (0, _isPast.isPast)((0, _subMinutes.subMinutes)(dt, 10)) && (0, _isFuture.isFuture)((0, _addMinutes.addMinutes)(dt, approxEnd));
                var btn = query(".sn-oddslivebtn", row);
                var cells = queryAll(".sn-cell", row);
                // const rowText = cells[0].innerText.trim() + ' ' + query('.sn-bold', cells[1]).innerText.trim()
                if (btn) {
                    if (isPlaying) // console.log('keep', rowText);
                    return;
                    // console.log('remove', rowText);
                    btn.remove();
                    return;
                }
                if (!isPlaying) return;
                if (cells.length < 2) return;
                // console.log('create', rowText);
                var newBtn = document.createElement("a");
                newBtn.classList.add("sn-oddslivebtn");
                newBtn.href = link;
                newBtn.innerText = label;
                newBtn.target = "_blank";
                var cellIndex = isLivescores ? 2 : 1;
                setTimeout(function() {
                    return cells[cellIndex].append(newBtn);
                }, 0);
            });
        });
    };
    if (!showOddsLiveBtnTables.length) return;
    setInterval(updateOddsLiveBtn, 30000);
    updateOddsLiveBtn();
})();
var openMatchWindow = function(el) {
    var width = 680;
    var height = 900;
    // const { width: screenWidth, height: screenHeight } = window.screen;
    // var dualScreenLeft =
    // 	window.screenLeft !== undefined ? window.screenLeft : screen.left;
    // var dualScreenTop =
    // 	window.screenTop !== undefined ? window.screenTop : screen.top;
    // const left = Math.round(screenWidth / 2 - width / 2) + dualScreenLeft;
    // const top = Math.round(screenHeight / 2 - height / 2) + dualScreenTop;
    var features = [
        "popup=1",
        "menubar=0",
        "status=0",
        "toolbar=0",
        // `top=${top}`,
        // `left=${left}`,
        // `screenY=${top}`,
        // `screenX=${left}`,
        "width=".concat(width),
        "height=".concat(height),
        "innerWidth=".concat(width),
        "innerHeight=".concat(height)
    ];
    window.open(el.href, "sportnyhet-match", features.join(","));
};
queryAll("a.sn-row, .sn-row-match-link").forEach(function(el) {
    el.addEventListener("click", function(event) {
        event.preventDefault();
        event.stopPropagation();
        openMatchWindow(el);
    });
});

},{"date-fns/isPast":"9S4ll","date-fns/isFuture":"5dCVh","date-fns/isToday":"bLztA","date-fns/addMinutes":"ltiTs","date-fns/subMinutes":"acMGh","date-fns/parseISO":"hEdIf","date-fns/differenceInMinutes":"6dfcU","lodash/isNumber":"dCSbf","./odds":"6hFkY","./sportnyhet-data.scss":"v70jX","@parcel/transformer-js/src/esmodule-helpers.js":"k7j9y"}],"9S4ll":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * @name isPast
 * @category Common Helpers
 * @summary Is the given date in the past?
 * @pure false
 *
 * @description
 * Is the given date in the past?
 *
 * @param date - The date to check
 *
 * @returns The date is in the past
 *
 * @example
 * // If today is 6 October 2014, is 2 July 2014 in the past?
 * const result = isPast(new Date(2014, 6, 2))
 * //=> true
 */ parcelHelpers.export(exports, "isPast", function() {
    return isPast;
});
var _toDateJs = require("./toDate.js");
function isPast(date) {
    return +(0, _toDateJs.toDate)(date) < Date.now();
}
// Fallback for modularized imports:
exports.default = isPast;

},{"./toDate.js":"gbb6O","@parcel/transformer-js/src/esmodule-helpers.js":"k7j9y"}],"gbb6O":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * @name toDate
 * @category Common Helpers
 * @summary Convert the given argument to an instance of Date.
 *
 * @description
 * Convert the given argument to an instance of Date.
 *
 * If the argument is an instance of Date, the function returns its clone.
 *
 * If the argument is a number, it is treated as a timestamp.
 *
 * If the argument is none of the above, the function returns Invalid Date.
 *
 * Starting from v3.7.0, it clones a date using `[Symbol.for("constructDateFrom")]`
 * enabling to transfer extra properties from the reference date to the new date.
 * It's useful for extensions like [`TZDate`](https://github.com/date-fns/tz)
 * that accept a time zone as a constructor argument.
 *
 * **Note**: *all* Date arguments passed to any *date-fns* function is processed by `toDate`.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 * @typeParam ResultDate - The result `Date` type, it is the type returned from the context function if it is passed, or inferred from the arguments.
 *
 * @param argument - The value to convert
 *
 * @returns The parsed date in the local time zone
 *
 * @example
 * // Clone the date:
 * const result = toDate(new Date(2014, 1, 11, 11, 30, 30))
 * //=> Tue Feb 11 2014 11:30:30
 *
 * @example
 * // Convert the timestamp to date:
 * const result = toDate(1392098430000)
 * //=> Tue Feb 11 2014 11:30:30
 */ parcelHelpers.export(exports, "toDate", function() {
    return toDate;
});
var _constructFromJs = require("./constructFrom.js");
function toDate(argument, context) {
    // [TODO] Get rid of `toDate` or `constructFrom`?
    return (0, _constructFromJs.constructFrom)(context || argument, argument);
}
// Fallback for modularized imports:
exports.default = toDate;

},{"./constructFrom.js":"8AeoQ","@parcel/transformer-js/src/esmodule-helpers.js":"k7j9y"}],"8AeoQ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * @name constructFrom
 * @category Generic Helpers
 * @summary Constructs a date using the reference date and the value
 *
 * @description
 * The function constructs a new date using the constructor from the reference
 * date and the given value. It helps to build generic functions that accept
 * date extensions.
 *
 * It defaults to `Date` if the passed reference date is a number or a string.
 *
 * Starting from v3.7.0, it allows to construct a date using `[Symbol.for("constructDateFrom")]`
 * enabling to transfer extra properties from the reference date to the new date.
 * It's useful for extensions like [`TZDate`](https://github.com/date-fns/tz)
 * that accept a time zone as a constructor argument.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The reference date to take constructor from
 * @param value - The value to create the date
 *
 * @returns Date initialized using the given date and value
 *
 * @example
 * import { constructFrom } from "./constructFrom/date-fns";
 *
 * // A function that clones a date preserving the original type
 * function cloneDate<DateType extends Date>(date: DateType): DateType {
 *   return constructFrom(
 *     date, // Use constructor from the given date
 *     date.getTime() // Use the date value to create a new date
 *   );
 * }
 */ parcelHelpers.export(exports, "constructFrom", function() {
    return constructFrom;
});
var _typeOf = require("@swc/helpers/_/_type_of");
var _constantsJs = require("./constants.js");
function constructFrom(date, value) {
    if (typeof date === "function") return date(value);
    if (date && (typeof date === "undefined" ? "undefined" : (0, _typeOf._)(date)) === "object" && (0, _constantsJs.constructFromSymbol) in date) return date[0, _constantsJs.constructFromSymbol](value);
    if (date instanceof Date) return new date.constructor(value);
    return new Date(value);
}
// Fallback for modularized imports:
exports.default = constructFrom;

},{"@swc/helpers/_/_type_of":"hn03S","./constants.js":"c1Fme","@parcel/transformer-js/src/esmodule-helpers.js":"k7j9y"}],"hn03S":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "_", function() {
    return _type_of;
});
function _type_of(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k7j9y"}],"k7j9y":[function(require,module,exports,__globalThis) {
exports.interopDefault = function(a) {
    return a && a.__esModule ? a : {
        default: a
    };
};
exports.defineInteropFlag = function(a) {
    Object.defineProperty(a, '__esModule', {
        value: true
    });
};
exports.exportAll = function(source, dest) {
    Object.keys(source).forEach(function(key) {
        if (key === 'default' || key === '__esModule' || Object.prototype.hasOwnProperty.call(dest, key)) return;
        Object.defineProperty(dest, key, {
            enumerable: true,
            get: function get() {
                return source[key];
            }
        });
    });
    return dest;
};
exports.export = function(dest, destName, get) {
    Object.defineProperty(dest, destName, {
        enumerable: true,
        get: get
    });
};

},{}],"c1Fme":[function(require,module,exports,__globalThis) {
/**
 * @module constants
 * @summary Useful constants
 * @description
 * Collection of useful date constants.
 *
 * The constants could be imported from `date-fns/constants`:
 *
 * ```ts
 * import { maxTime, minTime } from "./constants/date-fns/constants";
 *
 * function isAllowedTime(time) {
 *   return time <= maxTime && time >= minTime;
 * }
 * ```
 */ /**
 * @constant
 * @name daysInWeek
 * @summary Days in 1 week.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "daysInWeek", function() {
    return daysInWeek;
});
parcelHelpers.export(exports, "daysInYear", function() {
    return daysInYear;
});
parcelHelpers.export(exports, "maxTime", function() {
    return maxTime;
});
parcelHelpers.export(exports, "minTime", function() {
    return minTime;
});
parcelHelpers.export(exports, "millisecondsInWeek", function() {
    return millisecondsInWeek;
});
parcelHelpers.export(exports, "millisecondsInDay", function() {
    return millisecondsInDay;
});
parcelHelpers.export(exports, "millisecondsInMinute", function() {
    return millisecondsInMinute;
});
parcelHelpers.export(exports, "millisecondsInHour", function() {
    return millisecondsInHour;
});
parcelHelpers.export(exports, "millisecondsInSecond", function() {
    return millisecondsInSecond;
});
parcelHelpers.export(exports, "minutesInYear", function() {
    return minutesInYear;
});
parcelHelpers.export(exports, "minutesInMonth", function() {
    return minutesInMonth;
});
parcelHelpers.export(exports, "minutesInDay", function() {
    return minutesInDay;
});
parcelHelpers.export(exports, "minutesInHour", function() {
    return minutesInHour;
});
parcelHelpers.export(exports, "monthsInQuarter", function() {
    return monthsInQuarter;
});
parcelHelpers.export(exports, "monthsInYear", function() {
    return monthsInYear;
});
parcelHelpers.export(exports, "quartersInYear", function() {
    return quartersInYear;
});
parcelHelpers.export(exports, "secondsInHour", function() {
    return secondsInHour;
});
parcelHelpers.export(exports, "secondsInMinute", function() {
    return secondsInMinute;
});
parcelHelpers.export(exports, "secondsInDay", function() {
    return secondsInDay;
});
parcelHelpers.export(exports, "secondsInWeek", function() {
    return secondsInWeek;
});
parcelHelpers.export(exports, "secondsInYear", function() {
    return secondsInYear;
});
parcelHelpers.export(exports, "secondsInMonth", function() {
    return secondsInMonth;
});
parcelHelpers.export(exports, "secondsInQuarter", function() {
    return secondsInQuarter;
});
parcelHelpers.export(exports, "constructFromSymbol", function() {
    return constructFromSymbol;
});
var daysInWeek = 7;
var daysInYear = 365.2425;
var maxTime = Math.pow(10, 8) * 86400000;
var minTime = -maxTime;
var millisecondsInWeek = 604800000;
var millisecondsInDay = 86400000;
var millisecondsInMinute = 60000;
var millisecondsInHour = 3600000;
var millisecondsInSecond = 1000;
var minutesInYear = 525600;
var minutesInMonth = 43200;
var minutesInDay = 1440;
var minutesInHour = 60;
var monthsInQuarter = 3;
var monthsInYear = 12;
var quartersInYear = 4;
var secondsInHour = 3600;
var secondsInMinute = 60;
var secondsInDay = secondsInHour * 24;
var secondsInWeek = secondsInDay * 7;
var secondsInYear = secondsInDay * daysInYear;
var secondsInMonth = secondsInYear / 12;
var secondsInQuarter = secondsInMonth * 3;
var constructFromSymbol = Symbol.for("constructDateFrom");

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k7j9y"}],"5dCVh":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * @name isFuture
 * @category Common Helpers
 * @summary Is the given date in the future?
 * @pure false
 *
 * @description
 * Is the given date in the future?
 *
 * @param date - The date to check
 *
 * @returns The date is in the future
 *
 * @example
 * // If today is 6 October 2014, is 31 December 2014 in the future?
 * const result = isFuture(new Date(2014, 11, 31))
 * //=> true
 */ parcelHelpers.export(exports, "isFuture", function() {
    return isFuture;
});
var _toDateJs = require("./toDate.js");
function isFuture(date) {
    return +(0, _toDateJs.toDate)(date) > Date.now();
}
// Fallback for modularized imports:
exports.default = isFuture;

},{"./toDate.js":"gbb6O","@parcel/transformer-js/src/esmodule-helpers.js":"k7j9y"}],"bLztA":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * The {@link isToday} function options.
 */ /**
 * @name isToday
 * @category Day Helpers
 * @summary Is the given date today?
 * @pure false
 *
 * @description
 * Is the given date today?
 *
 * @param date - The date to check
 * @param options - An object with options
 *
 * @returns The date is today
 *
 * @example
 * // If today is 6 October 2014, is 6 October 14:00:00 today?
 * const result = isToday(new Date(2014, 9, 6, 14, 0))
 * //=> true
 */ parcelHelpers.export(exports, "isToday", function() {
    return isToday;
});
var _constructFromJs = require("./constructFrom.js");
var _constructNowJs = require("./constructNow.js");
var _isSameDayJs = require("./isSameDay.js");
function isToday(date, options) {
    return (0, _isSameDayJs.isSameDay)((0, _constructFromJs.constructFrom)((options === null || options === void 0 ? void 0 : options.in) || date, date), (0, _constructNowJs.constructNow)((options === null || options === void 0 ? void 0 : options.in) || date));
}
// Fallback for modularized imports:
exports.default = isToday;

},{"./constructFrom.js":"8AeoQ","./constructNow.js":"8u7IW","./isSameDay.js":"9zOMf","@parcel/transformer-js/src/esmodule-helpers.js":"k7j9y"}],"8u7IW":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * @name constructNow
 * @category Generic Helpers
 * @summary Constructs a new current date using the passed value constructor.
 * @pure false
 *
 * @description
 * The function constructs a new current date using the constructor from
 * the reference date. It helps to build generic functions that accept date
 * extensions and use the current date.
 *
 * It defaults to `Date` if the passed reference date is a number or a string.
 *
 * @param date - The reference date to take constructor from
 *
 * @returns Current date initialized using the given date constructor
 *
 * @example
 * import { constructNow, isSameDay } from 'date-fns'
 *
 * function isToday<DateType extends Date>(
 *   date: DateArg<DateType>,
 * ): boolean {
 *   // If we were to use `new Date()` directly, the function would  behave
 *   // differently in different timezones and return false for the same date.
 *   return isSameDay(date, constructNow(date));
 * }
 */ parcelHelpers.export(exports, "constructNow", function() {
    return constructNow;
});
var _constructFromJs = require("./constructFrom.js");
function constructNow(date) {
    return (0, _constructFromJs.constructFrom)(date, Date.now());
}
// Fallback for modularized imports:
exports.default = constructNow;

},{"./constructFrom.js":"8AeoQ","@parcel/transformer-js/src/esmodule-helpers.js":"k7j9y"}],"9zOMf":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * The {@link isSameDay} function options.
 */ /**
 * @name isSameDay
 * @category Day Helpers
 * @summary Are the given dates in the same day (and year and month)?
 *
 * @description
 * Are the given dates in the same day (and year and month)?
 *
 * @param laterDate - The first date to check
 * @param earlierDate - The second date to check
 * @param options - An object with options
 *
 * @returns The dates are in the same day (and year and month)
 *
 * @example
 * // Are 4 September 06:00:00 and 4 September 18:00:00 in the same day?
 * const result = isSameDay(new Date(2014, 8, 4, 6, 0), new Date(2014, 8, 4, 18, 0))
 * //=> true
 *
 * @example
 * // Are 4 September and 4 October in the same day?
 * const result = isSameDay(new Date(2014, 8, 4), new Date(2014, 9, 4))
 * //=> false
 *
 * @example
 * // Are 4 September, 2014 and 4 September, 2015 in the same day?
 * const result = isSameDay(new Date(2014, 8, 4), new Date(2015, 8, 4))
 * //=> false
 */ parcelHelpers.export(exports, "isSameDay", function() {
    return isSameDay;
});
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
var _normalizeDatesJs = require("./_lib/normalizeDates.js");
var _startOfDayJs = require("./startOfDay.js");
function isSameDay(laterDate, earlierDate, options) {
    var _normalizeDates = (0, _slicedToArray._)((0, _normalizeDatesJs.normalizeDates)(options === null || options === void 0 ? void 0 : options.in, laterDate, earlierDate), 2), dateLeft_ = _normalizeDates[0], dateRight_ = _normalizeDates[1];
    return +(0, _startOfDayJs.startOfDay)(dateLeft_) === +(0, _startOfDayJs.startOfDay)(dateRight_);
}
// Fallback for modularized imports:
exports.default = isSameDay;

},{"@swc/helpers/_/_sliced_to_array":"ak6Yu","./_lib/normalizeDates.js":"1pbtK","./startOfDay.js":"7vJHs","@parcel/transformer-js/src/esmodule-helpers.js":"k7j9y"}],"ak6Yu":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "_", function() {
    return _sliced_to_array;
});
var _arrayWithHolesJs = require("./_array_with_holes.js");
var _iterableToArrayLimitJs = require("./_iterable_to_array_limit.js");
var _nonIterableRestJs = require("./_non_iterable_rest.js");
var _unsupportedIterableToArrayJs = require("./_unsupported_iterable_to_array.js");
function _sliced_to_array(arr, i) {
    return (0, _arrayWithHolesJs._)(arr) || (0, _iterableToArrayLimitJs._)(arr, i) || (0, _unsupportedIterableToArrayJs._)(arr, i) || (0, _nonIterableRestJs._)();
}

},{"./_array_with_holes.js":"2SHeK","./_iterable_to_array_limit.js":"ajqiy","./_non_iterable_rest.js":"bGdxa","./_unsupported_iterable_to_array.js":"ebT39","@parcel/transformer-js/src/esmodule-helpers.js":"k7j9y"}],"2SHeK":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "_", function() {
    return _array_with_holes;
});
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k7j9y"}],"ajqiy":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "_", function() {
    return _iterable_to_array_limit;
});
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k7j9y"}],"bGdxa":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "_", function() {
    return _non_iterable_rest;
});
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k7j9y"}],"ebT39":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "_", function() {
    return _unsupported_iterable_to_array;
});
var _arrayLikeToArrayJs = require("./_array_like_to_array.js");
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return (0, _arrayLikeToArrayJs._)(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return (0, _arrayLikeToArrayJs._)(o, minLen);
}

},{"./_array_like_to_array.js":"f9wEp","@parcel/transformer-js/src/esmodule-helpers.js":"k7j9y"}],"f9wEp":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "_", function() {
    return _array_like_to_array;
});
function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k7j9y"}],"1pbtK":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "normalizeDates", function() {
    return normalizeDates;
});
var _typeOf = require("@swc/helpers/_/_type_of");
var _constructFromJs = require("../constructFrom.js");
function normalizeDates(context) {
    for(var _len = arguments.length, dates = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        dates[_key - 1] = arguments[_key];
    }
    var normalize = (0, _constructFromJs.constructFrom).bind(null, context || dates.find(function(date) {
        return (typeof date === "undefined" ? "undefined" : (0, _typeOf._)(date)) === "object";
    }));
    return dates.map(normalize);
}

},{"@swc/helpers/_/_type_of":"hn03S","../constructFrom.js":"8AeoQ","@parcel/transformer-js/src/esmodule-helpers.js":"k7j9y"}],"7vJHs":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * The {@link startOfDay} function options.
 */ /**
 * @name startOfDay
 * @category Day Helpers
 * @summary Return the start of a day for the given date.
 *
 * @description
 * Return the start of a day for the given date.
 * The result will be in the local timezone.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 * @typeParam ResultDate - The result `Date` type, it is the type returned from the context function if it is passed, or inferred from the arguments.
 *
 * @param date - The original date
 * @param options - The options
 *
 * @returns The start of a day
 *
 * @example
 * // The start of a day for 2 September 2014 11:55:00:
 * const result = startOfDay(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Tue Sep 02 2014 00:00:00
 */ parcelHelpers.export(exports, "startOfDay", function() {
    return startOfDay;
});
var _toDateJs = require("./toDate.js");
function startOfDay(date, options) {
    var _date = (0, _toDateJs.toDate)(date, options === null || options === void 0 ? void 0 : options.in);
    _date.setHours(0, 0, 0, 0);
    return _date;
}
// Fallback for modularized imports:
exports.default = startOfDay;

},{"./toDate.js":"gbb6O","@parcel/transformer-js/src/esmodule-helpers.js":"k7j9y"}],"ltiTs":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * The {@link addMinutes} function options.
 */ /**
 * @name addMinutes
 * @category Minute Helpers
 * @summary Add the specified number of minutes to the given date.
 *
 * @description
 * Add the specified number of minutes to the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 * @typeParam ResultDate - The result `Date` type, it is the type returned from the context function if it is passed, or inferred from the arguments.
 *
 * @param date - The date to be changed
 * @param amount - The amount of minutes to be added.
 * @param options - An object with options
 *
 * @returns The new date with the minutes added
 *
 * @example
 * // Add 30 minutes to 10 July 2014 12:00:00:
 * const result = addMinutes(new Date(2014, 6, 10, 12, 0), 30)
 * //=> Thu Jul 10 2014 12:30:00
 */ parcelHelpers.export(exports, "addMinutes", function() {
    return addMinutes;
});
var _constantsJs = require("./constants.js");
var _toDateJs = require("./toDate.js");
function addMinutes(date, amount, options) {
    var _date = (0, _toDateJs.toDate)(date, options === null || options === void 0 ? void 0 : options.in);
    _date.setTime(_date.getTime() + amount * (0, _constantsJs.millisecondsInMinute));
    return _date;
}
// Fallback for modularized imports:
exports.default = addMinutes;

},{"./constants.js":"c1Fme","./toDate.js":"gbb6O","@parcel/transformer-js/src/esmodule-helpers.js":"k7j9y"}],"acMGh":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * The {@link subMinutes} function options.
 */ /**
 * @name subMinutes
 * @category Minute Helpers
 * @summary Subtract the specified number of minutes from the given date.
 *
 * @description
 * Subtract the specified number of minutes from the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 * @typeParam ResultDate - The result `Date` type, it is the type returned from the context function if it is passed, or inferred from the arguments.
 *
 * @param date - The date to be changed
 * @param amount - The amount of minutes to be subtracted.
 * @param options - An object with options
 *
 * @returns The new date with the minutes subtracted
 *
 * @example
 * // Subtract 30 minutes from 10 July 2014 12:00:00:
 * const result = subMinutes(new Date(2014, 6, 10, 12, 0), 30)
 * //=> Thu Jul 10 2014 11:30:00
 */ parcelHelpers.export(exports, "subMinutes", function() {
    return subMinutes;
});
var _addMinutesJs = require("./addMinutes.js");
function subMinutes(date, amount, options) {
    return (0, _addMinutesJs.addMinutes)(date, -amount, options);
}
// Fallback for modularized imports:
exports.default = subMinutes;

},{"./addMinutes.js":"ltiTs","@parcel/transformer-js/src/esmodule-helpers.js":"k7j9y"}],"hEdIf":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * The {@link parseISO} function options.
 */ /**
 * @name parseISO
 * @category Common Helpers
 * @summary Parse ISO string
 *
 * @description
 * Parse the given string in ISO 8601 format and return an instance of Date.
 *
 * Function accepts complete ISO 8601 formats as well as partial implementations.
 * ISO 8601: http://en.wikipedia.org/wiki/ISO_8601
 *
 * If the argument isn't a string, the function cannot parse the string or
 * the values are invalid, it returns Invalid Date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 * @typeParam ResultDate - The result `Date` type, it is the type returned from the context function if it is passed, or inferred from the arguments.
 *
 * @param argument - The value to convert
 * @param options - An object with options
 *
 * @returns The parsed date in the local time zone
 *
 * @example
 * // Convert string '2014-02-11T11:30:30' to date:
 * const result = parseISO('2014-02-11T11:30:30')
 * //=> Tue Feb 11 2014 11:30:30
 *
 * @example
 * // Convert string '+02014101' to date,
 * // if the additional number of digits in the extended year format is 1:
 * const result = parseISO('+02014101', { additionalDigits: 1 })
 * //=> Fri Apr 11 2014 00:00:00
 */ parcelHelpers.export(exports, "parseISO", function() {
    return parseISO;
});
var _constantsJs = require("./constants.js");
var _constructFromJs = require("./constructFrom.js");
var _toDateJs = require("./toDate.js");
function parseISO(argument, options) {
    var invalidDate = function() {
        return (0, _constructFromJs.constructFrom)(options === null || options === void 0 ? void 0 : options.in, NaN);
    };
    var _options_additionalDigits;
    var additionalDigits = (_options_additionalDigits = options === null || options === void 0 ? void 0 : options.additionalDigits) !== null && _options_additionalDigits !== void 0 ? _options_additionalDigits : 2;
    var dateStrings = splitDateString(argument);
    var date;
    if (dateStrings.date) {
        var parseYearResult = parseYear(dateStrings.date, additionalDigits);
        date = parseDate(parseYearResult.restDateString, parseYearResult.year);
    }
    if (!date || isNaN(+date)) return invalidDate();
    var timestamp = +date;
    var time = 0;
    var offset;
    if (dateStrings.time) {
        time = parseTime(dateStrings.time);
        if (isNaN(time)) return invalidDate();
    }
    if (dateStrings.timezone) {
        offset = parseTimezone(dateStrings.timezone);
        if (isNaN(offset)) return invalidDate();
    } else {
        var tmpDate = new Date(timestamp + time);
        var result = (0, _toDateJs.toDate)(0, options === null || options === void 0 ? void 0 : options.in);
        result.setFullYear(tmpDate.getUTCFullYear(), tmpDate.getUTCMonth(), tmpDate.getUTCDate());
        result.setHours(tmpDate.getUTCHours(), tmpDate.getUTCMinutes(), tmpDate.getUTCSeconds(), tmpDate.getUTCMilliseconds());
        return result;
    }
    return (0, _toDateJs.toDate)(timestamp + time + offset, options === null || options === void 0 ? void 0 : options.in);
}
var patterns = {
    dateTimeDelimiter: /[T ]/,
    timeZoneDelimiter: /[Z ]/i,
    timezone: /([Z+-].*)$/
};
var dateRegex = /^-?(?:(\d{3})|(\d{2})(?:-?(\d{2}))?|W(\d{2})(?:-?(\d{1}))?|)$/;
var timeRegex = /^(\d{2}(?:[.,]\d*)?)(?::?(\d{2}(?:[.,]\d*)?))?(?::?(\d{2}(?:[.,]\d*)?))?$/;
var timezoneRegex = /^([+-])(\d{2})(?::?(\d{2}))?$/;
function splitDateString(dateString) {
    var dateStrings = {};
    var array = dateString.split(patterns.dateTimeDelimiter);
    var timeString;
    // The regex match should only return at maximum two array elements.
    // [date], [time], or [date, time].
    if (array.length > 2) return dateStrings;
    if (/:/.test(array[0])) timeString = array[0];
    else {
        dateStrings.date = array[0];
        timeString = array[1];
        if (patterns.timeZoneDelimiter.test(dateStrings.date)) {
            dateStrings.date = dateString.split(patterns.timeZoneDelimiter)[0];
            timeString = dateString.substr(dateStrings.date.length, dateString.length);
        }
    }
    if (timeString) {
        var token = patterns.timezone.exec(timeString);
        if (token) {
            dateStrings.time = timeString.replace(token[1], "");
            dateStrings.timezone = token[1];
        } else dateStrings.time = timeString;
    }
    return dateStrings;
}
function parseYear(dateString, additionalDigits) {
    var regex = new RegExp("^(?:(\\d{4}|[+-]\\d{" + (4 + additionalDigits) + "})|(\\d{2}|[+-]\\d{" + (2 + additionalDigits) + "})$)");
    var captures = dateString.match(regex);
    // Invalid ISO-formatted year
    if (!captures) return {
        year: NaN,
        restDateString: ""
    };
    var year = captures[1] ? parseInt(captures[1]) : null;
    var century = captures[2] ? parseInt(captures[2]) : null;
    // either year or century is null, not both
    return {
        year: century === null ? year : century * 100,
        restDateString: dateString.slice((captures[1] || captures[2]).length)
    };
}
function parseDate(dateString, year) {
    // Invalid ISO-formatted year
    if (year === null) return new Date(NaN);
    var captures = dateString.match(dateRegex);
    // Invalid ISO-formatted string
    if (!captures) return new Date(NaN);
    var isWeekDate = !!captures[4];
    var dayOfYear = parseDateUnit(captures[1]);
    var month = parseDateUnit(captures[2]) - 1;
    var day = parseDateUnit(captures[3]);
    var week = parseDateUnit(captures[4]);
    var dayOfWeek = parseDateUnit(captures[5]) - 1;
    if (isWeekDate) {
        if (!validateWeekDate(year, week, dayOfWeek)) return new Date(NaN);
        return dayOfISOWeekYear(year, week, dayOfWeek);
    } else {
        var date = new Date(0);
        if (!validateDate(year, month, day) || !validateDayOfYearDate(year, dayOfYear)) return new Date(NaN);
        date.setUTCFullYear(year, month, Math.max(dayOfYear, day));
        return date;
    }
}
function parseDateUnit(value) {
    return value ? parseInt(value) : 1;
}
function parseTime(timeString) {
    var captures = timeString.match(timeRegex);
    if (!captures) return NaN; // Invalid ISO-formatted time
    var hours = parseTimeUnit(captures[1]);
    var minutes = parseTimeUnit(captures[2]);
    var seconds = parseTimeUnit(captures[3]);
    if (!validateTime(hours, minutes, seconds)) return NaN;
    return hours * (0, _constantsJs.millisecondsInHour) + minutes * (0, _constantsJs.millisecondsInMinute) + seconds * 1000;
}
function parseTimeUnit(value) {
    return value && parseFloat(value.replace(",", ".")) || 0;
}
function parseTimezone(timezoneString) {
    if (timezoneString === "Z") return 0;
    var captures = timezoneString.match(timezoneRegex);
    if (!captures) return 0;
    var sign = captures[1] === "+" ? -1 : 1;
    var hours = parseInt(captures[2]);
    var minutes = captures[3] && parseInt(captures[3]) || 0;
    if (!validateTimezone(hours, minutes)) return NaN;
    return sign * (hours * (0, _constantsJs.millisecondsInHour) + minutes * (0, _constantsJs.millisecondsInMinute));
}
function dayOfISOWeekYear(isoWeekYear, week, day) {
    var date = new Date(0);
    date.setUTCFullYear(isoWeekYear, 0, 4);
    var fourthOfJanuaryDay = date.getUTCDay() || 7;
    var diff = (week - 1) * 7 + day + 1 - fourthOfJanuaryDay;
    date.setUTCDate(date.getUTCDate() + diff);
    return date;
}
// Validation functions
// February is null to handle the leap year (using ||)
var daysInMonths = [
    31,
    null,
    31,
    30,
    31,
    30,
    31,
    31,
    30,
    31,
    30,
    31
];
function isLeapYearIndex(year) {
    return year % 400 === 0 || year % 4 === 0 && year % 100 !== 0;
}
function validateDate(year, month, date) {
    return month >= 0 && month <= 11 && date >= 1 && date <= (daysInMonths[month] || (isLeapYearIndex(year) ? 29 : 28));
}
function validateDayOfYearDate(year, dayOfYear) {
    return dayOfYear >= 1 && dayOfYear <= (isLeapYearIndex(year) ? 366 : 365);
}
function validateWeekDate(_year, week, day) {
    return week >= 1 && week <= 53 && day >= 0 && day <= 6;
}
function validateTime(hours, minutes, seconds) {
    if (hours === 24) return minutes === 0 && seconds === 0;
    return seconds >= 0 && seconds < 60 && minutes >= 0 && minutes < 60 && hours >= 0 && hours < 25;
}
function validateTimezone(_hours, minutes) {
    return minutes >= 0 && minutes <= 59;
}
// Fallback for modularized imports:
exports.default = parseISO;

},{"./constants.js":"c1Fme","./constructFrom.js":"8AeoQ","./toDate.js":"gbb6O","@parcel/transformer-js/src/esmodule-helpers.js":"k7j9y"}],"6dfcU":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * The {@link differenceInMinutes} function options.
 */ /**
 * @name differenceInMinutes
 * @category Minute Helpers
 * @summary Get the number of minutes between the given dates.
 *
 * @description
 * Get the signed number of full (rounded towards 0) minutes between the given dates.
 *
 * @param dateLeft - The later date
 * @param dateRight - The earlier date
 * @param options - An object with options.
 *
 * @returns The number of minutes
 *
 * @example
 * // How many minutes are between 2 July 2014 12:07:59 and 2 July 2014 12:20:00?
 * const result = differenceInMinutes(
 *   new Date(2014, 6, 2, 12, 20, 0),
 *   new Date(2014, 6, 2, 12, 7, 59)
 * )
 * //=> 12
 *
 * @example
 * // How many minutes are between 10:01:59 and 10:00:00
 * const result = differenceInMinutes(
 *   new Date(2000, 0, 1, 10, 0, 0),
 *   new Date(2000, 0, 1, 10, 1, 59)
 * )
 * //=> -1
 */ parcelHelpers.export(exports, "differenceInMinutes", function() {
    return differenceInMinutes;
});
var _getRoundingMethodJs = require("./_lib/getRoundingMethod.js");
var _constantsJs = require("./constants.js");
var _differenceInMillisecondsJs = require("./differenceInMilliseconds.js");
function differenceInMinutes(dateLeft, dateRight, options) {
    var diff = (0, _differenceInMillisecondsJs.differenceInMilliseconds)(dateLeft, dateRight) / (0, _constantsJs.millisecondsInMinute);
    return (0, _getRoundingMethodJs.getRoundingMethod)(options === null || options === void 0 ? void 0 : options.roundingMethod)(diff);
}
// Fallback for modularized imports:
exports.default = differenceInMinutes;

},{"./_lib/getRoundingMethod.js":"6klYY","./constants.js":"c1Fme","./differenceInMilliseconds.js":"jpif1","@parcel/transformer-js/src/esmodule-helpers.js":"k7j9y"}],"6klYY":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getRoundingMethod", function() {
    return getRoundingMethod;
});
function getRoundingMethod(method) {
    return function(number) {
        var round = method ? Math[method] : Math.trunc;
        var result = round(number);
        // Prevent negative zero
        return result === 0 ? 0 : result;
    };
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k7j9y"}],"jpif1":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * @name differenceInMilliseconds
 * @category Millisecond Helpers
 * @summary Get the number of milliseconds between the given dates.
 *
 * @description
 * Get the number of milliseconds between the given dates.
 *
 * @param laterDate - The later date
 * @param earlierDate - The earlier date
 *
 * @returns The number of milliseconds
 *
 * @example
 * // How many milliseconds are between
 * // 2 July 2014 12:30:20.600 and 2 July 2014 12:30:21.700?
 * const result = differenceInMilliseconds(
 *   new Date(2014, 6, 2, 12, 30, 21, 700),
 *   new Date(2014, 6, 2, 12, 30, 20, 600)
 * )
 * //=> 1100
 */ parcelHelpers.export(exports, "differenceInMilliseconds", function() {
    return differenceInMilliseconds;
});
var _toDateJs = require("./toDate.js");
function differenceInMilliseconds(laterDate, earlierDate) {
    return +(0, _toDateJs.toDate)(laterDate) - +(0, _toDateJs.toDate)(earlierDate);
}
// Fallback for modularized imports:
exports.default = differenceInMilliseconds;

},{"./toDate.js":"gbb6O","@parcel/transformer-js/src/esmodule-helpers.js":"k7j9y"}],"dCSbf":[function(require,module,exports,__globalThis) {
var baseGetTag = require("d5df50bb79e32710"), isObjectLike = require("6ae0825ac2dae50f");
/** `Object#toString` result references. */ var numberTag = '[object Number]';
/**
 * Checks if `value` is classified as a `Number` primitive or object.
 *
 * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are
 * classified as numbers, use the `_.isFinite` method.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a number, else `false`.
 * @example
 *
 * _.isNumber(3);
 * // => true
 *
 * _.isNumber(Number.MIN_VALUE);
 * // => true
 *
 * _.isNumber(Infinity);
 * // => true
 *
 * _.isNumber('3');
 * // => false
 */ function isNumber(value) {
    return typeof value == 'number' || isObjectLike(value) && baseGetTag(value) == numberTag;
}
module.exports = isNumber;

},{"d5df50bb79e32710":"dwifZ","6ae0825ac2dae50f":"eViRG"}],"dwifZ":[function(require,module,exports,__globalThis) {
var Symbol = require("68a84eb98c5d3fa2"), getRawTag = require("9b2aaf31b7bdd837"), objectToString = require("46d5beb3375f8a28");
/** `Object#toString` result references. */ var nullTag = '[object Null]', undefinedTag = '[object Undefined]';
/** Built-in value references. */ var symToStringTag = Symbol ? Symbol.toStringTag : undefined;
/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ function baseGetTag(value) {
    if (value == null) return value === undefined ? undefinedTag : nullTag;
    return symToStringTag && symToStringTag in Object(value) ? getRawTag(value) : objectToString(value);
}
module.exports = baseGetTag;

},{"68a84eb98c5d3fa2":"9yf4T","9b2aaf31b7bdd837":"aonag","46d5beb3375f8a28":"3GMqN"}],"9yf4T":[function(require,module,exports,__globalThis) {
var root = require("9ff1abd51ad45ac0");
/** Built-in value references. */ var Symbol = root.Symbol;
module.exports = Symbol;

},{"9ff1abd51ad45ac0":"a21FN"}],"a21FN":[function(require,module,exports,__globalThis) {
var _typeOf = require("@swc/helpers/_/_type_of");
var freeGlobal = require("cd92e8811deaabf5");
/** Detect free variable `self`. */ var freeSelf = (typeof self === "undefined" ? "undefined" : (0, _typeOf._)(self)) == 'object' && self && self.Object === Object && self;
/** Used as a reference to the global object. */ var root = freeGlobal || freeSelf || Function('return this')();
module.exports = root;

},{"@swc/helpers/_/_type_of":"hn03S","cd92e8811deaabf5":"7Bs82"}],"7Bs82":[function(require,module,exports,__globalThis) {
/** Detect free variable `global` from Node.js. */ var _typeOf = require("@swc/helpers/_/_type_of");
var global = arguments[3];
var freeGlobal = (typeof global === "undefined" ? "undefined" : (0, _typeOf._)(global)) == 'object' && global && global.Object === Object && global;
module.exports = freeGlobal;

},{"@swc/helpers/_/_type_of":"hn03S"}],"aonag":[function(require,module,exports,__globalThis) {
var Symbol = require("e9b4533b2a68f814");
/** Used for built-in method references. */ var objectProto = Object.prototype;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var nativeObjectToString = objectProto.toString;
/** Built-in value references. */ var symToStringTag = Symbol ? Symbol.toStringTag : undefined;
/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */ function getRawTag(value) {
    var isOwn = hasOwnProperty.call(value, symToStringTag), tag = value[symToStringTag];
    try {
        value[symToStringTag] = undefined;
        var unmasked = true;
    } catch (e) {}
    var result = nativeObjectToString.call(value);
    if (unmasked) {
        if (isOwn) value[symToStringTag] = tag;
        else delete value[symToStringTag];
    }
    return result;
}
module.exports = getRawTag;

},{"e9b4533b2a68f814":"9yf4T"}],"3GMqN":[function(require,module,exports,__globalThis) {
/** Used for built-in method references. */ var objectProto = Object.prototype;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var nativeObjectToString = objectProto.toString;
/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */ function objectToString(value) {
    return nativeObjectToString.call(value);
}
module.exports = objectToString;

},{}],"eViRG":[function(require,module,exports,__globalThis) {
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ var _typeOf = require("@swc/helpers/_/_type_of");
function isObjectLike(value) {
    return value != null && (typeof value === "undefined" ? "undefined" : (0, _typeOf._)(value)) == 'object';
}
module.exports = isObjectLike;

},{"@swc/helpers/_/_type_of":"hn03S"}],"6hFkY":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "createOddsElement", function() {
    return createOddsElement;
});
parcelHelpers.export(exports, "createOverUnderLine", function() {
    return createOverUnderLine;
});
var createOddsElement = function(param) {
    var sport = param.sport, odds = param.odds, url = param.url, label = param.label, types = param.types;
    if (!Array.isArray(odds)) return null;
    return odds.map(function(param) {
        var type = param.type, data = param.data;
        if (!types.includes(type)) return null;
        switch(type){
            case "3way-result":
                return create3wayResult(sport, data, url, label);
            case "over-under-line":
                return createOverUnderLine(sport, data, url, label);
        }
        return null;
    }).filter(function(item) {
        return item !== null;
    }).join("\n");
};
var create3wayResult = function(sport, data, url, label) {
    var home = data["1"];
    var draw = data["x"];
    var away = data["2"];
    var variation = data.variation;
    if (!home || !draw || !away) return null;
    if (!url) url = "/till/".concat(sport, "-odds/");
    return '<span class="sn-live-odds-item"><a href="'.concat(url, '" target="_blank" class="sn-odds-link">\n	<table class="sn-odds sn-odds--1">\n	<tbody><tr class="sn-odds-row">\n	<th class="sn-odds-title">').concat(label, '</th>\n	<td class="sn-odds-cell"><span class="sn-odds-item"><span class="sn-odds-item-label">1</span><span class="sn-odds-item-value">').concat(home, '</span></span></td>\n	<td class="sn-odds-cell"><span class="sn-odds-item"><span class="sn-odds-item-label">X</span><span class="sn-odds-item-value">').concat(draw, '</span></span></td>\n	<td class="sn-odds-cell"><span class="sn-odds-item"><span class="sn-odds-item-label">2</span><span class="sn-odds-item-value">').concat(away, "</span></span></td>\n	").concat(variation ? '<td class="sn-odds-variation">('.concat(variation, ")</td>") : "", "\n	</tr>\n	</tbody></table>\n	</a></span>");
};
var createOverUnderLine = function(sport, data, url, label) {
    var _data_over = data.over, overTotal = _data_over.total, over = _data_over.value, _data_under = data.under, underTotal = _data_under.total, under = _data_under.value;
    if (!over || !under) return null;
    if (!url) url = "/till/".concat(sport, "-odds/");
    return '<span class="sn-live-odds-item"><a href="'.concat(url, '" target="_blank" class="sn-odds-link">\n	<table class="sn-odds sn-odds--5">\n	<tbody><tr class="sn-odds-row">\n	<th class="sn-odds-title">').concat(label, '</th>\n	<td class="sn-odds-cell"><span class="sn-odds-item"><span class="sn-odds-item-label"><span class="sn-data-text-sm" data-before="\xd6"></span><span class="sn-hidden-sm">\xd6ver</span> ').concat(over, '</span><span class="sn-odds-item-value">').concat(overTotal, '</span></span></td>\n	<td class="sn-odds-cell"><span class="sn-odds-item"><span class="sn-odds-item-label"><span class="sn-data-text-sm" data-before="U"></span><span class="sn-hidden-sm">Under</span> ').concat(under, '</span><span class="sn-odds-item-value">').concat(underTotal, "</span></span></td>\n	</tr>\n	</tbody></table>\n	</a></span>");
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k7j9y"}],"v70jX":[function() {},{}]},["kJVwu"], "kJVwu", "parcelRequire7427", {})

//# sourceMappingURL=sportnyhet-data.js.map
